module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/99b2b7361d516f2054b3bf8fbc015252.png";